import React from 'react';

const Card = ({ 
  children, 
  variant = 'default', 
  className = '',
  onClick,
  ...props 
}) => {
  const variantClasses = {
    default: 'rounded-lg shadow-md p-6 border border-white/10 bg-[#0f1d32] text-white',
    philosophical: 'rounded-lg p-6 shadow-sm border border-philosophicalPurple/20 bg-[#0f1d32] text-white',
    oracle: 'rounded-lg p-6 shadow-sm border border-oracleGreen/20 bg-[#0f1d32] text-white',
    elevated: 'rounded-lg shadow-lg p-6 border border-white/10 bg-[#0f1d32] text-white',
    interactive: 'rounded-lg shadow-md p-6 border border-white/10 bg-[#0f1d32] text-white hover:bg-[#162a4a] transition-all cursor-pointer',
  };
  
  const classes = `${variantClasses[variant]} ${className}`;
  
  return (
    <div 
      className={classes} 
      onClick={onClick}
      {...props}
    >
      {children}
    </div>
  );
};

export default Card;